export default function PatientPolicy() {
	return (
		<iframe
			src="https://www.hemiteams.ai/patient-data-protection-policy"
			title="Patient Data Protection Policy"
			className="w-full h-full aspect-square"
		/>
	);
}
